import { createAsyncThunk } from '@reduxjs/toolkit';
import Api, { FetchParams, AuthenticationMethod } from '../utils/Api';
import processPaymentGatewayToken from '../utils/processors/processPaymentGatewayToken';
import {
  getEnableDynamicPaymentGatewayConfig,
  getGatewayType,
} from '../selectors';
import { setPaymentGatewayConfigPaymentMethods } from '../reducers/currentOrder/paymentGatewayConfig';
import { setPaymentGatewayTokens } from '../reducers/paymentGatewayTokens';
import { PAYMENT_GATEWAY_TYPES } from '../constants';

export const removePaymentGatewayToken = createAsyncThunk(
  '$removePaymentGatewayToken',
  async (
    data: {
      token: string;
      authenticationMethod?: AuthenticationMethod;
    },
    { dispatch, getState, rejectWithValue },
  ) => {
    const { token, authenticationMethod = 'member' } = data;

    try {
      const gatewayType = getGatewayType(getState() as EntireFrontendState);
      const isRedcatPay = gatewayType === PAYMENT_GATEWAY_TYPES.REDCAT_PAY;

      const params: FetchParams = {
        path: isRedcatPay
          ? `/api/v2/online-payments/cards/${token}`
          : `/api/v1/profile/pgtokens/${token}`,
        method: 'DELETE',
      };

      const response = await Api.fetch(params, authenticationMethod);

      const enableDynamicPaymentGatewayConfig =
        getEnableDynamicPaymentGatewayConfig(getState() as EntireFrontendState);

      if (enableDynamicPaymentGatewayConfig) {
        dispatch(setPaymentGatewayConfigPaymentMethods(response.data));
      } else {
        const rawTokens: RawPaymentGatewayToken[] = response.data;
        const processedTokens = rawTokens.map(processPaymentGatewayToken);

        dispatch(setPaymentGatewayTokens(processedTokens));

        return {
          token: processedTokens,
        };
      }
    } catch (e) {
      console.error('Remove payment gateway token failed', { e });
      return rejectWithValue(e);
    }
  },
);
